import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { ErrorMessage } from "formik";
import {
  Wrapper,
  Input,
  Label,
  LabelText,
  LabelLink,
  Error,
} from "./styles/checkbox-styles";

interface Props {
  field: unknown;
  name: string;
  isError: boolean;
  error: string;
  labelText: string;
  labelLink: string;
  labelLinkName: string;
}

const Checkbox: FunctionComponent<Props> = ({ field, ...props }) => {
  const { name, isError, labelText, labelLink, labelLinkName, error } = props;

  return (
    <Wrapper>
      <Input {...field} {...props} id={name} />
      <Label htmlFor={name} isError={isError}>
        <LabelText>
          {labelText}
          <LabelLink
            isError={isError}
            href={labelLink}
            title={`View ${labelLinkName}`}
            rel="noopener"
            target="_blank"
          >
            {labelLinkName}
          </LabelLink>
          .
        </LabelText>
      </Label>
      <Error aria-label={error}>
        <ErrorMessage name={name} />
      </Error>
    </Wrapper>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  labelLink: PropTypes.string.isRequired,
  labelLinkName: PropTypes.string.isRequired,
  field: PropTypes.shape({}).isRequired,
  isError: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
};

export default Checkbox;
